import { render, staticRenderFns } from "./PlanningStaffsV3.vue?vue&type=template&id=8507eb68&scoped=true"
import script from "./PlanningStaffsV3.vue?vue&type=script&lang=js"
export * from "./PlanningStaffsV3.vue?vue&type=script&lang=js"
import style0 from "./PlanningStaffsV3.vue?vue&type=style&index=0&id=8507eb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8507eb68",
  null
  
)

export default component.exports